<template>
    <div class="hsq-panel">
        <div class="hsq-panel-header">
            <slot></slot>
        </div>
        <div  class="hsq-panel-content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "hsqPanel"
    }
</script>

<style scoped>
    .hsq-panel {
        background-color: #f7f7f7;
        border-radius: 3px;
        border: 1px solid #dcdee2;
        display: flex;
        flex-direction: column;
    }

    .hsq-panel>.hsq-panel-header {
        height: 38px;
        line-height: 38px;
        padding-left: 16px;
        color: #666;
        /*cursor: pointer;*/
        /*position: relative;*/
        border-bottom: 1px solid transparent;
        /*transition: all .2s ease-in-out;*/
    }

    .hsq-panel>.hsq-panel-content {
        color: #515a6e;
        padding: 16px;
        background-color: #fff;
        flex-grow: 1;
    }
</style>